import { useEffect, useState } from 'react';
import './OnboardingModal.css';

const CARD_W = 300;

const STEPS = [
  {
    selector: '.geo-status-widget',
    place: 'below',
    title: 'Your Location, Verified',
    body: 'BrowserGuard collects GPS, Wi-Fi & IP signals, encrypts them client-side, and confirms you\'re in a compliant jurisdiction. This badge updates live.',
  },
  {
    selector: '.geo-status-countdown',
    place: 'below',
    title: 'Stays Verified All Session',
    body: 'The countdown shows when the next automatic re-check runs. It also triggers on IP changes and device wake — no action needed from you.',
  },
  {
    selector: '.geo-monitor-btn',
    place: 'below',
    title: 'Behind the Scenes',
    body: 'Every SDK event, geo decision, and reason code — logged live. Click this button to see exactly what\'s happening under the hood.',
  },
];

function cardPosition(el, place) {
  const r = el.getBoundingClientRect();
  const gap = 14;
  const s = { width: CARD_W };
  if (place === 'below') {
    s.top = r.bottom + gap;
    let left = r.left + r.width / 2 - CARD_W / 2;
    s.left = Math.max(12, Math.min(left, window.innerWidth - CARD_W - 12));
  } else {
    s.bottom = 24;
    s.right = 24;
  }
  return s;
}

export default function OnboardingModal({ visible, step, onNext, onPrev, onSkip }) {
  const [style, setStyle] = useState({ bottom: 24, right: 24, width: CARD_W });
  const current = STEPS[step - 1];

  useEffect(() => {
    document.querySelectorAll('.ob-highlighted').forEach(e => e.classList.remove('ob-highlighted'));
    if (!visible || !current?.selector) return;
    const el = document.querySelector(current.selector);
    if (!el) return;
    el.classList.add('ob-highlighted');
    setStyle(cardPosition(el, current.place));
    return () => el.classList.remove('ob-highlighted');
  }, [step, visible]); // eslint-disable-line

  if (!visible || !current) return null;

  const isFirst = step === 1;
  const isLast  = step === STEPS.length;

  return (
    <div className="ob-card" style={style}>
      <div className="ob-head">
        <span className="ob-counter">{step} / {STEPS.length}</span>
        <button className="ob-x" onClick={onSkip}>✕</button>
      </div>
      <h3 className="ob-title">{current.title}</h3>
      <p className="ob-body">{current.body}</p>
      <div className="ob-foot">
        <button className="ob-back" onClick={onPrev} disabled={isFirst}>← Back</button>
        <button className="ob-next" onClick={isLast ? onSkip : onNext}>
          {isLast ? 'Done' : 'Next →'}
        </button>
      </div>
    </div>
  );
}
